import * as React from 'react';
import { apiEndpoints, PortalSharedDocumentView } from '../../../amorg-common';
import { portalClientApi } from '../../../api/portalClientApi';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { FileIcon } from '../../../designSystem/FileIcon';
import { EmployeePortalFileLinkWithTokenRefresh, FileLinkWithTokenRefresh } from '../../../designSystem/FileLinkWithTokenRefresh';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { MessageCard } from '../../../designSystem/MessageCard';
import { P } from '../../../designSystem/typography/Body';
import { H4 } from '../../../designSystem/typography/Heading';

export function LatestPortalFiles(): JSX.Element {
	const [loading, setLoading] = React.useState(true);
	const [files, setFiles] = React.useState<PortalSharedDocumentView[]>([]);
	const [error, setError] = React.useState('');

	const employeePortalLink = true;

	React.useEffect(() => {
		const load = async () => {
			try {
				const result = await portalClientApi.getPortalFiles();
				const latest = result
					.sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime())
					.slice(0, 3);
				setFiles(latest);
			}
			catch {
				setError('Der opstod en fejl ved hentning af delte filer. Prøv igen senere.');
			}
			finally {
				setLoading(false);
			}
		};

		load();
	}, []);

	return (
		<>
			<LoadingPageOverlay loading={loading} />

			{error !== '' &&
				<MessageCard variant='error'>{error}</MessageCard>
			}

			{!loading && error === '' && files.length === 0 &&
				
				<P>Der er ikke delt nogen dokumenter eller filer</P>
				
			}

			{!loading && error === '' && files.length > 0 &&
				<Flex flexDirection='column' gap={12}>
					{files.map(file => (
						<Flex key={file.privateFileName} gap={16} alignItems='center' width='100%' style={{ minWidth: 0 }}>

							<Flex flexDirection='row' gap={8} justifyContent='space-between' alignItems='center' width='100%'>
								<Flex flexDirection='row' gap={8} alignItems='center' justifyContent='space-between' width='100%'>

									<Flex flexDirection='row' gap={8} alignItems='flex-start'>
										
										<FileIcon publicFileName={file.publicFileName} />
										
										<Flex flexDirection='column' gap={4} alignItems='flex-start'>
											<H4>
												{employeePortalLink
													?
														<EmployeePortalFileLinkWithTokenRefresh
															publicFileName={file.publicFileName}
															privateFileName={file.privateFileName}
															style={{ display:'block', overflow:'hidden', maxWidth:'100%' }} />
													:
														<FileLinkWithTokenRefresh
															publicFileName={file.publicFileName}
															privateFileName={file.privateFileName}
															style={{ display:'block', overflow:'hidden', maxWidth:'100%' }} />
												}
											</H4>
											{file.note && <P fontSize='small'>{file.note}</P>}
										</Flex>

									</Flex>
									<LinkButton
										variant='clean'
										text=''
										icon='interface_actions_download'
										href={apiEndpoints.portalfiles_privateFileName.replace(':privateFileName', file.privateFileName)}
										download={file.publicFileName}
									/>
								</Flex>
							</Flex>


							{/* <div style={{ flex: '1 1 0', minWidth: 0, overflow: 'hidden' }}>
                                
                            </div> */}

							{/* {file.note && file.note.trim() !== '' &&
                                <div style={{ flexShrink: 0 }}>
                                    <ToggletipTheOne icon='interface_glyph_comment'>
                                        {file.note}
                                    </ToggletipTheOne>
                                </div>
                            } */}

						</Flex>
					))}
				</Flex>
			}
		</>
	);
}
